import { useAppContext } from '../../contexts/AppContext';
import Notifications from '../../notifications/Notifications';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { userRoutes, filterMenusWithPlan } from '../../routes';
import { Logo } from '../Logo';
import { usePlanAccess } from '../../plans/usePlanAccess';
import { Menu } from 'lucide-react';

// Barra de navegacao do modo compacto (ate 1024px); no desktop a navegacao fica no Menu lateral.
export default function Header() {
    const { user } = useAuthContext();
    const location = useLocation();
    const [currentPath, setCurrentPath] = useState<any>();
    const { toggleShowDrawerMenu } = useAppContext();
    const { menuShowEntry } = usePlanAccess();

    useEffect(() => {
        if (!user) {
            return;
        }
        setCurrentPath(userRoutes(user).find((e: any) => e?.path === location.pathname));
    }, [location.pathname, user]);

    return (
        <div className="sf-toolbar-shell sf-mobile-header-shell relative flex h-14 items-center justify-between overflow-visible px-1">
            <div className="flex min-w-0 items-center gap-3">
                {user && filterMenusWithPlan(user, menuShowEntry).length > 1 && (
                    <button
                        type="button"
                        className="sf-mobile-toolbar-button sf-icon-button btn btn-sm btn-circle shrink-0"
                        onClick={() => {
                            toggleShowDrawerMenu();
                        }}
                        aria-label="Abrir navegação"
                    >
                        <Menu aria-hidden="true" />
                    </button>
                )}

                <div className="absolute left-1/2 -translate-x-1/2">
                    <Logo />
                </div>

                <div className="hidden min-w-0 sm:flex sm:flex-col">
                    <span className="truncate text-sm font-semibold text-base-content/75">
                        {currentPath?.title || 'Painel'}
                    </span>
                </div>
            </div>

            <div className="flex items-center justify-end gap-1.5 sm:gap-3">
                <Notifications />
            </div>
        </div>
    );
}
